import { render, staticRenderFns } from "./AdditionalActions.vue?vue&type=template&id=bed62802&scoped=true&"
import script from "./AdditionalActions.vue?vue&type=script&lang=js&"
export * from "./AdditionalActions.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalActions.vue?vue&type=style&index=0&id=bed62802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed62802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
